import { connect } from 'react-redux';
import { openChange } from './actions';
import OpenWidget from '../inputs/OpenWidget';
import { questionKey } from '../response/reducer';
import classnames from 'classnames';
import moment from 'moment';
import includes from 'lodash/includes';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  const field = question && question.values[ownProps.index];
  const attachments = state.attachmentsTmap && state.attachmentsTmap[question.name] && state.attachmentsTmap[question.name][ownProps.index] ? [state.attachmentsTmap[question.name][ownProps.index]] : [];
  const tempAttachmentKey = attachments.length > 0 ? attachments[0].temp_multi_attachment_key : question.temp_response_attachment_keys[ownProps.index];

  return {
    attachments: attachments,
    isValid:
      question &&
      (!question.fieldValids || question.fieldValids[ownProps.index]),
    className: classnames(ownProps.className, {
      'mb-20': includes(['date', 'time', 'datetime'], ownProps.field_type),
    }),
    value: field && field.value,
    uploaderConfig: {
      ...state.attachmentConfig,
      attachmentParams: {
        attachment: {
          surveyQuestionId: ownProps.questionId,
          tempMultiAttachmentKey: tempAttachmentKey,
        },
        attachableId: tempAttachmentKey,
        attachableType: 'Survey::Response',
        tokenId: state.token && state.token.id,
      },
      tempMultiAttachmentKeyFieldName: `questions[images][${question.name}][]`,
    },
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => {
    // date time widgets pass a date object, everything else passes an event
    const value =
      moment.isMoment(e) || moment.isDate(e) || typeof e === 'string'
        ? e
        : e.target.value;
    dispatch(openChange(value, ownProps.index, ownProps.questionId));
  },
});

const MultiInput = connect(mapStateToProps, mapDispatchToProps)(OpenWidget);

export default MultiInput;
